




































































































import { Component, Vue } from 'vue-property-decorator'
import authModule from '@/store/auth'
import dealModule from '@/store/deal'
import UserAvatar from '@/components/user/UserAvatar.vue'
import UserEditor from '@/components/user/UserEditor.vue'
import OnlineRedeemDialog from '@/components/deal/OnlineRedeemDialog.vue'

@Component({
  name: 'ProfileHeader',
  components: {
    UserAvatar,
    UserEditor,
    OnlineRedeemDialog
  }
})
class ProfileHeader extends Vue {
  private get user() {
    return authModule.user
  }

  private get points() {
    return (this.user!.points + 1) % 6
  }

  private get deals() {
    return dealModule.deals
  }
}
export default ProfileHeader
